import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    border: 'solid 1px #F4F4F4',
    borderBottom: 'none',
    backgroundColor: 'white',
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    display: 'flex',
    justifyContent: 'center',
    height: 80,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    zIndex: 1100,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
  },
  container: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 80,
    width: 1130,
  },
  rights: {
    color: '#C6CAC6',
    fontSize: 14,
    letterSpacing: 0.3,
  },
}));
